const wsProtocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
const url = `${wsProtocol}://${window.location.host}/websocket/notification/main`;

import { SocketClient } from './socket-client';

export type { SocketClient };

export const socket = new SocketClient(url);
